<template>
    <main>
        <div class="row">
            <div class="col-12">
                <div class="tile">
                    <div class="form-inline">
                        <client-select v-if="!clientId" class="mr-1 mb-2" :model="filterFormModel" attribute="client" @change="search"
                            :isFilter="true" :place-holder="$t('selectClient')"></client-select>
                        <form-select :model="filterFormModel" attribute="fromContact" class="mr-1 mb-2" :options="[
                            { value: null, text: this.$t('chooseType') },
                            { value: 'startFromCustomer', text: this.$t('startFromCustomer') },
                            { value: 'startFromUser', text: this.$t('startFromUser') },
                        ]"></form-select>
                        <form-select :model="filterFormModel" attribute="replied" class="mr-1 mb-2" :options="[
                            { value: null, text: $t('status') },
                            { value: 'replied', text: $t('replied') },
                            { value: 'notYetReply', text: $t('notYetReply') },
                        ]"></form-select>
                        <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"
                            :defaultShortcut="3"></time-range-picker>
                        <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
                        <button @click="reset" class="btn btn-secondary mr-1 mb-2">{{ $t('reset') }}</button>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount > 0">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <div class="c-paging__right">
                        <div class="c-paging__numbers">
                            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                                v-model="filterFormModel.page" :total-rows="itemCount"
                                :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="items.length > 0">
                <div class="c-smart-table tile">
                    <div class="row c-smart-table__title">
                        <div class="col-lg-2">{{ $t('customer') }}</div>
                        <div class="col-lg-2">{{ $t('inboxUser') }}</div>
                        <div class="col-lg-2">{{ $t('content') }}</div>
                        <div class="col-lg-2">{{ $t('info') }}</div>
                        <div class="col-lg-2">{{ $t('replied') }}</div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="row" v-for="(item, index) in items" :key="item._id">
                        <div class="col-lg-2">
                            <p v-if="item.client">
                                <b>{{ $t('client') }} : </b>
                                <span>{{ item.client.domain }}</span>
                            </p>
                            <p>
                                <span v-if="item.customer">
                                    {{ item.customer.name }}
                                </span>
                                <span v-else>
                                    {{ $t('unknown') }}
                                </span>
                                <span v-if="item.account && item.customer" class="badge badge-info">{{
                                    $t(item.account.type) }}
                                </span>
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <p v-if="item.user">
                                {{ item.user.name }}
                            </p>
                            <p v-else>
                                {{ $t('unknown') }}
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <p v-if="item.startMessage">
                                {{ item.startMessage.content }}
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <p>
                                <b>{{ $t('startTime') }}:&nbsp;</b>
                                <span>{{ item.startTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                            </p>
                            <p>
                                <b>{{ $t('startBy') }}:&nbsp;</b>
                                <span v-if="item.fromContact">{{ $t('customer') }}</span>
                                <span v-else>{{ $t('user') }}</span>
                            </p>
                            <p>
                                <b>{{ $t('endBy') }}:&nbsp;</b>
                                <span v-if="lastMessageSenders[index]">{{ $t('customer') }}</span>
                                <span v-else>{{ $t('user') }}</span>
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <p v-if="item.replied">
                                <span class="badge badge-success">
                                    {{ $t('replied') }}
                                </span>
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <div>
                                <button @click="getContent(item._id, item.customer, item.user)"
                                    class="btn btn-outline-secondary mr-1 mb-2">
                                    <i class="fa fa-info"></i>
                                    {{ $t('seeDetail') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">{{
                            $t('notFoundSearch')
                        }}
            </div>
            <div class="col-12" v-if="itemCount > 0">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
                    </b-pagination>

                </div>
            </div>
        </div>
        <b-modal v-model="showDetailModel" size="lg">
            <div class="row">
                <div class="col-12">
                    <p>
                        <span>{{ $t('customer') }}: </span>
                        <b>{{ customer }}</b>
                    </p>
                    <p>
                        <span>{{ $t('inboxUser') }}: </span>
                        <b>{{ user }}</b>
                    </p>
                    <p>
                        <span>{{ $t('content') }}: </span>
                    </p>
                    <div>
                        <div v-if="detail.length > 0" class="alert alert-info"
                            style="max-height: 400px; overflow-y: auto;">
                            <div class="c-message-item__content c-message-item"
                                :class="message.fromContact ? 'is-left' : 'is-right'" v-for="(message, index) in detail"
                                :key="index">
                                {{ message.content }}
                            </div>
                        </div>
                        <div v-else class="alert alert-info">
                            <div class="text-center text-danger">{{ $t('noData') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </main>
</template>

<style scoped>
.c-message-item__content {
    border-radius: 12px;
}

.is-right {
    margin-left: 70px;
}

.is-left {
    margin-right: 70px;
}

.c-message-item {
    background-color: white;
    padding: 8px 10px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}
</style>

<script>
import list from '@/mixins/List';
import utils from '@/utils';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import _ from 'lodash';
import moment from "moment";

export default {
    components: { TimeRangePicker, ClientSelect },
    mixins: [list, utils],
    props: {
        clientId: String,
    },
    data() {
        return {
            service: '/chat-session',
            autoLoad: true,
            lastMessageSenders: [],
            accountOptions: [],
            detail: [],
            showDetailModel: false,
            customer: null,
            user: null,
            defaultFilterFormModel: {
                fromContact: null,
                client: this.clientId || null,
                type: null,
                replied: null,
                from: moment().subtract('29', 'day').startOf('day').valueOf(),
                to: moment().endOf('day').valueOf(),
            }
        }
    },
    methods: {
        search: _.debounce(function () {
            this.filterFormModel.page = 1;
            this.load();
        }, 200),
        async getContent(id, customer, user) {
            const res = await this.$bgService.get(this.service + `/content/${id}`)
            if (res && res.data) {
                let data = res.data;
                data = data.sort((a, b) => {
                    return a.createTime - b.createTime
                });
                this.detail = data;
            }
            this.showDetailModel = true;
            this.customer = customer ? customer.name : this.$t('unknown');
            this.user = user ? user.name : this.$t('unknown');
        },
        async getLastMessageSenders() {
            const promises = this.items.map(item => this.lastMessageSender(item._id));
            return await Promise.all(promises);
        },
        async lastMessageSender(id) {
            const res = await this.$bgService.get(this.service + `/last-message-sender/${id}`);
            if (res && res.data) {
                if (res.data.fromContact) {
                    return res.data.fromContact;
                } else {
                    return false;
                }
            }
        },
    },
    watch: {
        items: {
            immediate: true,
            async handler() {
                this.lastMessageSenders = await this.getLastMessageSenders();
            }
        }
    },
    i18n: {
        messages: {
            en: {
                from: 'Sent from',
                toID: 'Sent to Facebook ID',
                time: 'Time',
                content: 'Content',
                createTime: 'Create time',
                sendTime: 'Send time',
                notYetSent: 'Not yet sent',
                messageCampaigns: "Message campaigns",
                messageTemplate: "template",
                seeTemplate: "See templates",
                smsType: 'Type',
                reset: 'Reset',
                message: "Message {0}",
                sent: "Sent",
                notFoundSearch: "No results found!",
                sentFail: "Sent failed",
                status: "Status",
                chooseType: "Choose type",
                chatBot: "Chatbot",
                autoReply: "Auto reply",
                question: "Question",
                theAnswer: "Answer",
                account: "Account",
                customer: "Customer",
                error: "Error",
                inboxUser: "Consultant",
                startTime: "Start time",
                startBy: "Start by",
                endBy: "End by",
                replied: "Replied",
                seeDetail: "See details",
                startFromCustomer: "Start from the customer",
                startFromUser: "Start from the user",
                notYetReply: "Not yet reply",
                facebook: "Facebook page",
                instagram: "Instagram",
                whatsapp: "Whatsapp",
                zalo: "Zalo OA",
                "zalo-user": "Zalo user",
            },
            vi: {
                from: 'Gửi từ',
                toID: 'Gửi tới Facebook ID',
                time: 'Thời gian',
                content: 'Nội dung',
                createTime: 'Tạo lúc',
                sendTime: 'Gửi lúc',
                messageTemplate: "Mẫu tin nhắn",
                messageCampaigns: "Chiến dịch gửi tin nhắn",
                seeTemplate: "Xem mẫu",
                notYetSent: 'Chưa gửi',
                smsType: 'Loại',
                reset: 'Đặt lại',
                message: "Tin nhắn {0}",
                sent: "Đã gửi",
                notFoundSearch: "Không tìm thấy kết quả nào!",
                sentFail: "Gửi thất bại",
                status: "Tình trạng",
                chooseType: "Chọn loại",
                chatBot: "Chatbot",
                autoReply: "Trả lời tự động",
                question: "Câu hỏi",
                theAnswer: "Câu trả lời",
                account: "Tài khoản",
                customer: "Khách hàng",
                error: "Có lỗi",
                inboxUser: "Nhân viên tư vấn",
                startTime: "Bắt đầu lúc",
                startBy: "Bắt đầu bởi",
                endBy: "Kết thúc bởi",
                replied: "Đã phản hồi",
                seeDetail: "Xem chi tiết",
                startFromCustomer: "Bắt đầu từ khách hàng",
                startFromUser: "Bắt đầu từ người dùng",
                notYetReply: "Chưa phản hồi",
                facebook: "Trang facebook",
                instagram: "Instagram",
                whatsapp: "Whatsapp",
                zalo: "Zalo OA",
                "zalo-user": "Zalo cá nhân",
            }
        }
    },
}
</script>